'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PlayerHeader = require('../PlayerHeader');

var _PlayerHeader2 = _interopRequireDefault(_PlayerHeader);

var _StatsTable = require('../StatsTable');

var _StatsTable2 = _interopRequireDefault(_StatsTable);

var _withContentCardFooter = require('../../hocs/withContentCardFooter');

var _withContentCardFooter2 = _interopRequireDefault(_withContentCardFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RotoPlayerStatsContentCard = function RotoPlayerStatsContentCard(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_PlayerHeader2.default, {
      headshotUrl: props.headshotUrl,
      name: props.name
    }),
    _react2.default.createElement(_StatsTable2.default, {
      alignment: props.alignment,
      awayTeam: props.awayTeam,
      homeTeam: props.homeTeam,
      gameDate: props.gameDate,
      stats: props.stats
    })
  );
};

RotoPlayerStatsContentCard.propTypes = {
  alignment: _propTypes2.default.string.isRequired,
  awayTeam: _propTypes2.default.string.isRequired,
  headshotUrl: _propTypes2.default.string.isRequired,
  homeTeam: _propTypes2.default.string.isRequired,
  gameDate: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  stats: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    stat: _propTypes2.default.string.isRequired
  })).isRequired
};

RotoPlayerStatsContentCard.displayName = 'RotoPlayerStatsContentCard';

exports.default = (0, _withContentCardFooter2.default)(RotoPlayerStatsContentCard);